import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import LoginWave from "../../components/Vectors/LoginWave";
import { Box } from "@mui/system";
import "./ForgotPassword";
import ForgotPasswordEmailSentIcon from "../../components/Vectors/img/forgotPasswordEmailSent.png";

const ForgotPasswordEmailSent = () => {
  const paperStyle = {
    padding: 20,
    overflow: "auto",
    width: "80vw",
    maxWidth: 460,
    margin: "12px auto",
  };

  const ResponsiveLogoBox = styled("div")(({ theme }) => ({
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      paddingTop: "10vh",
    },
    [theme.breakpoints.down("md")]: {
      paddingTop: "1vh",
    },
  }));

  return (
    <React.Fragment>
      <LoginWave />
      <Box
        layout="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        style={{ width: [100, 100, 550, 550, 550], margin: "0 auto" }}
      >
        <ResponsiveLogoBox></ResponsiveLogoBox>

        <Paper elevation={10} style={paperStyle}>
          <Grid container direction={"column"} spacing={6}>
            <Grid item align="center">
              <h2
                style={{
                  fontSize: "24px",
                  lineHeight: "32px",
                  fontWeight: "bold",
                }}
              >
                Confira seu e-mail
              </h2>
              <img
                height="80px"
                style={{ marginBottom: "24px" }}
                alt="Esqueceu sua senha?"
                src={ForgotPasswordEmailSentIcon}
              />
              <h4
                style={{
                  fontSize: "16px",
                  lineHeight: "23px",
                  fontWeight: 400,
                }}
              >
                Se o e-mail que você digitou estiver cadastrado, você receberá
                um link para recuperar sua senha. <br /> <br />
                Verifique sua caixa de spam (lixo eletrônico).
              </h4>
            </Grid>
            <Grid item align="center">
              <Typography>
                <Link className="createAccount" to="/">
                  voltar para o login
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </React.Fragment>
  );
};

export default ForgotPasswordEmailSent;
